import React from 'react'
import { getOrdersList } from './../utils/api'
import { useState } from 'react'
import { useEffect } from 'react'
import moment from 'moment'
import Pagination from "react-js-pagination";

function OrdersList(props) {

    const [orders, setOrders] = useState([])
    const [queryData, setQueryData] = useState({ currentPage: 1, totalPages: 1, search: '', status: '' })

    useEffect(() => {
        getUserData()
    }, [queryData.currentPage])

    function pageChanged(page) {
        let temp = { ...queryData }
        let getUsersFlag = false
        if (temp.currentPage === 1 && page === 1) {
            getUsersFlag = true
        }
        temp.currentPage = page
        setQueryData(temp)
        if (getUsersFlag) {
            getUserData()
        }
    }

    async function getUserData() {
        try {
            let response = await getOrdersList(queryData)
            if (response) {
                let temp = []
                temp = response.data.orders
                temp.forEach(item => {
                    if (!item.user[0]) {
                        item.user[0] = { firstName: 'User Deleted', primaryPhone: '', primaryEmail: '' }
                    }
                })
                setOrders(temp)
                let tempData = { ...queryData }
                tempData.totalPages = response.data.totalPages
                setQueryData(tempData)
            }
        } catch (err) {
            console.log(err)
        }
    }

    function inputValueChanged(event) {
        let temp = { ...queryData }
        temp[event.target.name] = event.target.value
        setQueryData(temp)
    }

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <form>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="inputEmail4">Name/Email/Phone</label>
                                    <input type="text" className="form-control" value={queryData.search} name="search" onChange={inputValueChanged} />
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="inputState">Status</label>
                                    <select id="inputState" className="form-control" value={queryData.status} name="status" onChange={inputValueChanged}>
                                        <option value="" selected>All</option>
                                        <option value="complete">Complete</option>
                                        <option value="incomplete">Incomplete</option>
                                    </select>
                                </div>
                            </div>
                            <button type="button" onClick={e => { pageChanged(1) }} className="btn btn-primary">Apply</button>
                        </form>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-plain table-plain-bg">
                            <div className="card-header">
                                <h4 className="card-title">Transaction List - {queryData.totalPages}</h4>
                                <p className="card-category">Transactions happened on your app</p>
                            </div>
                            <div className="card-header">
                            </div>
                            <div className="card-body table-full-width table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Phone/Email</th>
                                            <th>Name</th>
                                            <th>Payment For</th>
                                            <th>Amount</th>
                                            <th>Payment Mode</th>
                                            <th>Reference Id</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.user[0].primaryPhone}{item.user[0].primaryEmail}</td>
                                                <td>{item.user[0].firstName}</td>
                                                <td>{item.paymentFor}</td>
                                                <td>{item.paymentAmount}</td>
                                                <td>{item.paymentMode || '-'}</td>
                                                <td>{item.referenceId || '-'}</td>
                                                <td>{item.status}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Pagination
                            activePage={queryData.currentPage}
                            itemsCountPerPage={10}
                            totalItemsCount={queryData.totalPages}
                            pageRangeDisplayed={5}
                            itemClass="page-item"
                            linkClass="page-link"
                            onChange={pageChanged}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export { OrdersList }
